<template>
  <b-card body-class="text-center">
    <template #header>
      <small class="text-muted">精选企业</small>
    </template>

    <b-card-group deck class="mb-2" v-for="(item, index) in compList" :key="index">
      <b-card :img-src="obj.logoUrl" img-alt="Image" img-left img-height="100px" img-width="100px" no-body v-for="(obj, i) in item" :key="i">
        <div class="ml-2 mt-1 mr-2">
          <div class="comp-name mb-1 text-left">
            <b-link :to="'/show-comp/' + obj.compId" target="_blank" class="news-list">{{ obj.compName }}</b-link>
          </div>
          <div class="comp-prop text-muted mb-1 text-left">{{ obj.bizType }} | {{ obj.bizSize }} | {{ obj.bizIndustry }}</div>
          <div class="comp-prop text-muted text-left">{{ obj.compAddr }}</div>
        </div>
      </b-card>
    </b-card-group>

    <b-button to="/search-comp" target="_blank" variant="primary">查看更多精选企业</b-button>
  </b-card>
</template>

<script>
export default {
  name: 'ChoiceCompZone',
  data() {
    return {
      // 企业列表
      compList: []
    }
  },
  mounted() {
    this.fetchCompList()
  },
  methods: {
    // 获取企业列表
    fetchCompList() {
      const that = this
      const postData = {}
      that
        .$http({
          method: 'post',
          url: '/portal/comp-list',
          data: postData
        })
        .then((d) => {
          const compSize = d.length
          let tmpArr = []

          for (let i = 0; i < compSize; i++) {
            const comp = d[i]

            const tmp = i % 3
            if (tmp === 0) {
              tmpArr = []
              tmpArr.push(comp)

              that.compList.push(tmpArr)
            } else {
              tmpArr.push(comp)
            }
          }
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取企业列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.comp-name {
  font-size: 16px;
  font-weight: bold;
}
.comp-prop {
  font-size: 14px;
}
</style>
